var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-bth",on:{"click":_vm.jump}},[(_vm.type == 1)?_c('span',[_vm._v(_vm._s(_vm.$t("message.strid47")))]):_vm._e(),(_vm.type == 2)?_c('span',[_vm._v(_vm._s(_vm.$t("message.strid49")))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }